import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
	Grid,
	TextField,
	FormControlLabel, FormControl, Checkbox, FormGroup,
} from '@material-ui/core';

import {
	FormSelect,
	DatePicker,
	FormAutocomplete,
} from '@components/Coliving';

import PhoneInput from '../../../Coliving/components/PhoneInput';

import getOptions from './selectInputOptions';

import { useTranslation } from '@common/utils';

const CheckOutInputsForm = ({ visibleCheckOutFormInputs = [], props = () => { }, roomReservation, values }) => {
	const tr = useTranslation();
	const { locale } = useSelector(state => state.locale);

	const options = getOptions();

	if (visibleCheckOutFormInputs.find(i => i.id === 'stayPurpose') && values.stayPurpose !== 'study') {
		visibleCheckOutFormInputs = visibleCheckOutFormInputs.filter(i => i.studyPurposeValueCondition !== 'study');
	}

	return (
		<>
			{visibleCheckOutFormInputs.filter(i => !i.companyField).map(input => {
				const prop = input.id || undefined;
				const i18n = input?.i18n || {};

				if (prop === 'faculty' && values.faculty === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('Faculty name')} {...props('otherFaculty')} />
							</Grid>
						</>
					);
				}

				if (prop === 'universityName' && values.universityName === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('University name')} {...props('otherUniversityName')} />
							</Grid>
						</>
					);
				}

				if (prop === 'company') {
					return (
						<Grid key={2} item xs={12}>
							<FormControl component="fieldset">
								<FormGroup>
									<FormControlLabel
										control={<Checkbox color="primary" value={values.company} onChange={() => props(prop).setFieldValue('company', !values.company)} />}
										label={i18n[locale]?.alias || tr(input.label)}
									/>
								</FormGroup>
							</FormControl>
						</Grid>
					);
				}

				return (
					<>
						<Grid key={prop} item xs={12} sm={6} style={{ position: 'relative' }}>
							{(input.type === 'text' || input.type === 'email' || input.type === 'number') && (
								<TextField
									fullWidth
									required={input.required}
									variant="outlined"
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
								/>
							)}
							{prop != null && input.type === 'date' && !input.withAdditionalProps && (
								<DatePicker
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{prop != null && input.type === 'date' && input.withAdditionalProps && (
								<DatePicker
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
									minDate={roomReservation?.from}
									maxDate={roomReservation?.to}
									required={input.required}
									clearable
								/>
							)}
							{input.type === 'single-choice' && (
								<FormSelect
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{input.type === 'autocomplete' && (
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{input.type === 'phone-number' && (
								<PhoneInput
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
						</Grid>
					</>
				);
			})}
			{visibleCheckOutFormInputs.filter(i => i.companyField === true).map(input => {
				const prop = input.id || undefined;
				const i18n = input?.i18n || {};

				if (prop === 'company') {
					return (
						<Grid key={2} item xs={12}>
							<FormControl component="fieldset">
								<FormGroup>
									<FormControlLabel
										control={<Checkbox color="primary" value={values.company} onChange={() => props(prop).setFieldValue(prop, !values.company)} />}
										label={i18n[locale]?.alias || tr(input.label)}
									/>
								</FormGroup>
							</FormControl>
						</Grid>
					);
				}
				if (values.company) {
					return (
						<Grid key={prop} item xs={12} sm={6} style={{ position: 'relative' }}>
							{(input.type === 'text' || input.type === 'email' || input.type === 'number') && (
								<TextField
									fullWidth
									required={input.required}
									variant="outlined"
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
								/>
							)}
						</Grid>
					);
				}
			})}
		</>
	);
};

CheckOutInputsForm.propTypes = {
	props: PropTypes.func.isRequired,
	visibleCheckOutFormInputs: PropTypes.array.isRequired,
	roomReservation: PropTypes.object,
	isAdditional: PropTypes.bool,
	index: PropTypes.bool,
	values: PropTypes.object.isRequired,
};

export default CheckOutInputsForm;
